const type = "en-US";

const format = {
  year: "numeric",
  weekday: "long",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: false,
};

export const dateFormat = (date) => {
  date = new Date(date);
  return date.toLocaleString(type, format);
};
